<template>
    <xx-category-select-input @input="input" :categoryId="value" v-on="$listeners" v-bind="$attrs"></xx-category-select-input>
</template>

<script>
import XxCategorySelectInput from '../../CategorySelectInput';

export default {
    name: 'XxProductCategory',
    props: {
        value: {
            required: true
        }
    },
    components: {
        XxCategorySelectInput
    },
    watch: {},
    methods: {
        input(val) {
            this.$emit('input', val);
        }
    }
};
</script>
